/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Who may set the task to DONE. CREATOR_APPROVED (default): the assignee finishes at DONE_NOT_CONFIRMED and only the creator sets DONE. ASSIGNEE_COMPLETES: the assignee sets DONE. A missing value in a request means CREATOR_APPROVED.
 */

export const TaskCompletionModeDto = {
    CreatorApproved: 'CREATOR_APPROVED',
    AssigneeCompletes: 'ASSIGNEE_COMPLETES',
} as const;

export type TaskCompletionModeDto = typeof TaskCompletionModeDto[keyof typeof TaskCompletionModeDto];



